var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row justify-content-end" },
    [
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary btn-lg",
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-ban" }),
            _vm._v(" " + _vm._s(_vm.resource("Button_Cancel")) + "\n        ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-danger btn-lg",
            class: { disabled: !_vm.canWrite },
            on: { click: _vm.promptUser }
          },
          [
            _c("i", { staticClass: "fa fa-trash" }),
            _vm._v(" " + _vm._s(_vm.resource("Button_Remove")) + "\n        ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-lg",
            class: { disabled: _vm.disableSave },
            on: { click: _vm.save }
          },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _vm._v(" " + _vm._s(_vm.resource("Button_Save")) + "\n        ")
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPrompt
        ? _c("prompt", {
            attrs: {
              title: _vm.promptValues.title,
              icon: "fa fa-trash",
              body: _vm.promptValues.body,
              buttons: [
                {
                  name: _vm.resource("Button_No"),
                  class: "btn btn-secondary btn-sm",
                  emit: "no",
                  icon: "fa fa-times"
                },
                {
                  name: _vm.resource("Button_Yes"),
                  class: "btn btn-primary btn-sm",
                  emit: "yes",
                  icon: "fas fa-check"
                }
              ]
            },
            on: {
              yes: _vm.emitDelete,
              hidden: function($event) {
                _vm.showPrompt = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }